import ControlTableView from './control-table-view'
//import Vue from 'vue'

//Vue.component("control-table-view",ControlTableView)

const params = {
  props: {
    schemaUrl: "/api/pointObjectForShootingTasks/schema"
  },
}

export default [
  {
    name: 'control-table-view',
    path: '/control-table-view',
    component: {
      // data() {
      //   return {
      //     params
      //   }
      // },
      render(createElement) {
        return createElement(ControlTableView, params)
      }
    },
    meta: {requiresAuth: false},
  }
]
